import {del} from '../utils'

export default host => (id, producerId, tagId) => del(`${host}/playlists/${id}/contentCreators/${producerId}/tags/${tagId}`)
